import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    content:
      'From the following list, select the relevant regulatory considerations for this transaction?',
    subContent: '[Select all that apply]',
    subSection: 'Regulations',
    type: QUES_COMPONENT_TYPES.CHECKBOX,
    options: [
      { text: 'Yes - US Government Approval (CFIUS)' },
      { text: 'Yes - Foreign Regulatory Approval' },
      { text: 'Yes - Industry Restrictions' },
      { text: 'Yes - Anti-trust related (HSR)' },
      { text: 'Yes - DOJ' },
      { text: 'Yes - Other, Please enter', hasSupplement: true },
      { text: 'No', isExclusive: true },
    ],
  },
  {
    content:
      'Does the Buyer or Target (Seller) do business (with an active legal entity) in the following geographic regions?',
    subContent: '[Select all that apply]',
    subSection: 'Geographies',
    type: QUES_COMPONENT_TYPES.CHECKBOX,
    cols: 3,
    options: [
      { text: 'India' },
      { text: 'Russia or Ukraine' },
      { text: 'China' },
      { text: 'Brazil, Colombia or Venezuela' },
      {
        text: 'Middle East Countries (i.e., Iran, Iraq, Saudi Arabia, UAE, Pakistan, Afghanistan)',
      },
      { text: 'Germany' },
      { text: 'Austria' },
      { text: 'Luxumbourg' },
      { text: 'Netherland' },
      { text: 'Belgium' },
      { text: 'Italy' },
      { text: 'France' },
      { text: 'Spain' },
      { text: 'Denmark' },
      { text: 'UK' },
      { text: 'Other', hasSupplement: true },
      { text: 'None of these', isExclusive: true },
    ],
  },

  {
    content:
      'What is the level of facilities overlap for the Buyer and Target?',
    subSection: 'Facility Footprint',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: { count: 5, extremeTexts: ['no overlap', 'significant overlap'] },
  },

  {
    content: 'How challenging do you expect facility consolidation to be?',
    subSection: 'Facility Footprint',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: ['not challenging', 'very challenging'],
    },
  },

  {
    content:
      'Are there significant macroeconomic and / or industry trends that will impact the deal complexity?',
    subSection: 'Economic Environment',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Yes, More Complex' }, { text: 'No, Less Complex' }],
  },

  {
    content:
      'How do the macroeconomic and / or industry trends impact the deal complexity?',
    subSection: 'Economic Environment',
    type: QUES_COMPONENT_TYPES.INPUT,
  },
];
